export const getFormPopupContainer = (triggerNode) =>
  triggerNode?.closest?.('[data-bw-modal-overlay], .bw_modal') || document.body;
